import { render, staticRenderFns } from "./alarms.vue?vue&type=template&id=9d966d6c&scoped=true&"
import script from "./alarms.vue?vue&type=script&lang=js&"
export * from "./alarms.vue?vue&type=script&lang=js&"
import style0 from "./alarms.vue?vue&type=style&index=0&id=9d966d6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d966d6c",
  null
  
)

export default component.exports